<template>
  <div>
    <nav class="secondary-nav">
      <ul>
        <li :class="{ active: filter === 'active' }">
          <a
            @click.prevent="filter = 'active'"
            v-text="'Active'"
          />
        </li>
        <li :class="{ active: filter === 'disabled' }">
          <a
            @click.prevent="filter = 'disabled'"
            v-text="'Disabled'"
          />
        </li>
        <li :class="{ active: filter === 'draft' }">
          <a
            @click.prevent="filter = 'draft'"
            v-text="'Draft'"
          />
        </li>
      </ul>
    </nav>
    <div class="p-8">
      <div class="max-w-3xl flex-no-grow">
        <ManagedPages :filter="filter" />
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import ManagedPages from './ManagedPages'

export default {
  name: 'ManagedPagesIndex',
  components: {
    ManagedPages,
  },
  data() {
    return {
      filter: 'active',
    }
  },
}
</script>
